import { CommonState, ListParams, Pagination, Platform } from './common';
import { ClientList, ClientListParams, ExpiredDates, PaidDates } from './client';
import { PaymentTypes } from 'config';

export enum TypesMethods {
  manual = 'manual',
}

export enum TypesStatusesOrderPaid {
  paid = 1,
  unpaid = 2,
  canceledpaidyookassa = 3,
  canceledpaid = 4,
  frozen = 5,
}

type OrderPromocode = {
  id: number;
  code: string;
  deleted_at: string | null;
};

type OrderBase = {
  id: number;
  price: number;
  status: number | undefined;
  created_at: string;
  paid_at?: string;
  expired_at?: string;
  platform: Platform;
  platform_id?: string;
  payment_type: PaymentTypes;
  method: TypesMethods;
  promocode?: OrderPromocode | null;
};

interface OrderClientBase {
  deleted_at: string | null;
  email: string | null;
  id: number;
  name: string;
  phone: string | null;
}

export type FullOrder = OrderBase & {
  client_id: number | undefined;
  client?: OrderClientBase;
  product_id: number | undefined;
};

export type NewOrder = Omit<FullOrder, 'id' | 'price' | 'created_at' | 'payment_type'>;

type OrderClient = {
  id: number;
  name: string;
  phone: string;
  email: string;
  avatar: string;
};

type OrderProduct = {
  id: number;
  title: string;
};

export type OrderRow = OrderBase & {
  client: OrderClient;
  product: OrderProduct | null;
};

export type OrderList = {
  data?: OrderRow[];
  meta?: Pagination;
};

export enum PriceTypes {
  PRICE_FROM = 'price_from',
  PRICE_TO = 'price_to',
}

export type OrderListParams = ListParams &
  ExpiredDates &
  PaidDates & {
    [PriceTypes.PRICE_FROM]?: number;
    [PriceTypes.PRICE_TO]?: number;
    client_id?: number;
    product_id?: number;
    status?: number;
    platformType?: number;
    scan?: string;
    promocode?: string;
  };

export type PriceFromTo = {
  [PriceTypes.PRICE_FROM]?: string;
  [PriceTypes.PRICE_TO]?: string;
};

export type OrderState = CommonState & {
  order?: FullOrder;
  orderList: OrderList;
  orderListParams: OrderListParams;
  filtersListParams: OrderListParams;
  filtersErrors: ExpiredDates & PaidDates & PriceFromTo;
  orderClientList: ClientList;
  orderClientListParams: ClientListParams;
};

export type StatusObject =
  | undefined
  | {
      id: number;
      label: string;
    };

export type NewProduct = {
  id: number;
  label: string;
  description: string;
  price: string;
};

export type NewClient = {
  id: number;
  label: string;
  phone: string;
  email: string;
  avatar: string;
  active: boolean;
};
